import type { IAppSettings } from './appSettings.types';
import {
  devAppSettings,
  preprodAppSettings,
  prodAppSettings,
} from './environments';

export const getAppSettings = (): IAppSettings => {
  const environmentName = import.meta.env.MODE;

  switch (environmentName) {
    case 'dev':
      return devAppSettings;
    case 'preprod':
      return preprodAppSettings;
    case 'prod':
      return prodAppSettings;
    default:
      throw new Error(`Unsupported environment: \`${environmentName}\``);
  }
};
